import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _LocaleConfigMap;
import { Locale } from "./Locale";
export var LocaleConfigMap = (_LocaleConfigMap = {}, _defineProperty(_LocaleConfigMap, Locale.enUS, {
  locale: Locale.enUS,
  name: "English",
  antd: "en_US",
  zendesk: "en-US",
  tradingView: "en",
  isDefault: true,
  support: true
}), _defineProperty(_LocaleConfigMap, "zh-CN", {
  locale: Locale.zhCN,
  name: "简体中文",
  antd: "zh_CN",
  zendesk: "zh-cn",
  tradingView: "zh",
  support: true
}), _defineProperty(_LocaleConfigMap, "zh-TW", {
  locale: Locale.zhTW,
  name: "繁體中文",
  antd: "zh_TW",
  zendesk: "zh_tw",
  tradingView: "zh_TW",
  support: true
}), _defineProperty(_LocaleConfigMap, "ko", {
  locale: Locale.ko,
  name: "한국어",
  antd: "ko_KR",
  zendesk: "ko",
  tradingView: "ko",
  support: true
}), _defineProperty(_LocaleConfigMap, "id", {
  locale: Locale.id,
  name: "Bahasa Indonesia",
  antd: "en_US",
  zendesk: "id",
  tradingView: "en",
  support: true
}), _defineProperty(_LocaleConfigMap, "de", {
  locale: Locale.de,
  name: "Deutsch",
  // FIXME: 由于Antd组件以下语言均展示为韩语，因此全部降级指定为显示英语，需要修复。
  antd: "en_US",
  // "de_DE",
  zendesk: "de",
  tradingView: "de",
  support: true
}), _defineProperty(_LocaleConfigMap, "ja", {
  locale: Locale.ja,
  name: "日本語",
  antd: "en_US",
  // "ja_JP",
  zendesk: "ja",
  tradingView: "ja",
  support: true
}), _defineProperty(_LocaleConfigMap, "ms", {
  locale: Locale.ms,
  name: "Bahasa Malaysia",
  antd: "ms_MY",
  zendesk: "ms",
  tradingView: "ms_MY",
  support: true
}), _defineProperty(_LocaleConfigMap, "pt", {
  locale: Locale.pt,
  name: "Português",
  antd: "en_US",
  // "pt_PT",
  zendesk: "pt",
  tradingView: "pt",
  support: true
}), _defineProperty(_LocaleConfigMap, "es", {
  locale: Locale.es,
  name: "Español",
  antd: "en_US",
  // "es_ES",
  zendesk: "es",
  tradingView: "es",
  support: true
}), _defineProperty(_LocaleConfigMap, "th", {
  locale: Locale.th,
  name: "ภาษาไทย",
  antd: "en_US",
  //"th_TH",
  zendesk: "th",
  tradingView: "th",
  support: true
}), _defineProperty(_LocaleConfigMap, "ru", {
  locale: Locale.ru,
  name: "Pусский",
  antd: "en_US",
  // "ru_RU",
  zendesk: "ru",
  tradingView: "ru",
  support: true
}), _defineProperty(_LocaleConfigMap, "vi", {
  locale: Locale.vi,
  name: "Tiếng Việt",
  antd: "en_US",
  // "vi_VN",
  zendesk: "vi",
  tradingView: "vi",
  support: true
}), _defineProperty(_LocaleConfigMap, "ar", {
  locale: Locale.ar,
  name: "العربية",
  antd: "ar_EG",
  zendesk: "ar",
  tradingView: "ar",
  support: true
}), _defineProperty(_LocaleConfigMap, "fr", {
  locale: Locale.fr,
  name: "Français",
  antd: "fr_FR",
  zendesk: "fr",
  tradingView: "fr",
  support: true
}), _defineProperty(_LocaleConfigMap, "tr", {
  locale: Locale.tr,
  name: "Türkçe",
  antd: "tr_TR",
  zendesk: "tr",
  tradingView: "tr",
  support: true
}), _LocaleConfigMap);